import React from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, UserCheck, X } from "lucide-react";

/**
 * Small modal that asks the closer which demo to run for a lead.
 * Demo 1 -> /demo/live/:leadId  (BJA Full Stack — original)
 * Demo 2 -> /demo/live2/:leadId (ChillRefer first — $99 entry, BJA upsell)
 */
export default function DemoChoiceModal({ lead, onClose }) {
  const navigate = useNavigate();
  if (!lead) return null;

  const pick = (target) => {
    onClose?.();
    navigate(`/demo/${target}/${lead.id}`);
  };

  return (
    <div className="demo-choice-overlay" onClick={onClose} data-testid="demo-choice-overlay">
      <div className="demo-choice-card" onClick={(e) => e.stopPropagation()} data-testid="demo-choice-card">
        <button className="demo-choice-close" onClick={onClose} data-testid="demo-choice-close">
          <X className="w-4 h-4" />
        </button>
        <h3 className="demo-choice-title">Pick a demo for {lead.clientName}</h3>
        <p className="demo-choice-sub">Two playbooks. Pick the one that matches the lead's temperature.</p>

        <button
          className="demo-choice-option demo-choice-option-bja"
          onClick={() => pick("live")}
          data-testid="demo-choice-bja"
        >
          <div className="demo-choice-option-icon"><Briefcase className="w-5 h-5" /></div>
          <div className="demo-choice-option-body">
            <div className="demo-choice-option-name">Demo 1 — BulkJobApply Full Stack</div>
            <div className="demo-choice-option-desc">12 slides. Pitch $399 / $625 / $1,499 plans. Best for warm leads ready to commit.</div>
          </div>
        </button>

        <button
          className="demo-choice-option demo-choice-option-cr"
          onClick={() => pick("live2")}
          data-testid="demo-choice-cr"
        >
          <div className="demo-choice-option-icon"><UserCheck className="w-5 h-5" /></div>
          <div className="demo-choice-option-body">
            <div className="demo-choice-option-name">Demo 2 — ChillRefer first ($99 entry)</div>
            <div className="demo-choice-option-desc">11 slides. Close $99 ChillRefer first, then upsell BJA bundle. Best for top-of-funnel.</div>
          </div>
        </button>
      </div>
    </div>
  );
}
